import { AccessTimeFilled, Assistant, Notes, Videocam } from "@clockwise/design-system/icons";
import { Cached, CalendarTodayFilled } from "@clockwise/icons";
import { AccountCircle, Lock, Place, SvgIconComponent } from "@material-ui/icons";
import classNames from "classnames";
import React from "react";

export const eventSelections = [
  "flex",
  "attendee",
  "time",
  "recurrence",
  "video",
  "agenda",
  "location",
  "locked",
  "calendar",
] as const;
export type EventSection = typeof eventSelections[number];

const iconWithStylesMap: {
  [key in EventSection]: {
    icon: SvgIconComponent;
    heightOfTopRow?: string;
  };
} = {
  flex: {
    icon: Assistant,
    heightOfTopRow: "20px",
  },
  attendee: {
    icon: AccountCircle,
  },
  time: {
    icon: AccessTimeFilled,
    heightOfTopRow: "28px",
  },
  recurrence: {
    icon: Cached,
    heightOfTopRow: "28px",
  },
  video: {
    icon: Videocam,
    heightOfTopRow: "28px",
  },
  agenda: {
    icon: Notes,
  },
  location: {
    icon: Place,
  },
  locked: {
    icon: Lock,
  },
  calendar: {
    icon: CalendarTodayFilled,
    heightOfTopRow: "auto",
  },
};

export const EventElementsWrap = ({
  children,
  showChanges = false,
  name,
  icon: Icon,
}: {
  children: React.ReactNode;
  showChanges?: boolean;
  name: EventSection;
  icon?: SvgIconComponent;
}) => {
  const currentSection = iconWithStylesMap[name];
  const SectionIcon = Icon ? Icon : currentSection.icon;
  const icon = SectionIcon ? (
    <SectionIcon
      className={classNames("cw-w-4 cw-h-4", {
        "cw-text-muted-disabled": name !== "flex",
        "cw-text-positive": name === "flex",
      })}
      aria-hidden
    />
  ) : null;

  return (
    <div className="cw-flex cw-body-base cw-gap-3 cw-mx-4 first:cw-mt-1">
      <div
        className="cw-flex cw-items-center cw-relative"
        style={{ height: iconWithStylesMap[name].heightOfTopRow || "32px" }}
      >
        {icon}
        {showChanges && (
          <div
            aria-label={`user has modified ${name} field`}
            className={classNames(
              "cw-absolute cw-rounded-full cw-bg-busy-emphasis cw-w-2 cw-h-2 cw-z-[5] cw-right-[-3px] cw-top-[15px]",
            )}
          />
        )}
      </div>
      <div className="cw-flex cw-items-center cw-flex-1">{children}</div>
    </div>
  );
};
